import { render } from "./MSIdentify.vue?vue&type=template&id=251c5e34&scoped=true"
import script from "./MSIdentify.vue?vue&type=script&lang=js"
export * from "./MSIdentify.vue?vue&type=script&lang=js"

import "./MSIdentify.vue?vue&type=style&index=0&id=251c5e34&scoped=true&lang=css"

import exportComponent from "D:\\PRG\\gitEE\\wwj\\web\\htweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251c5e34"]])

export default __exports__